<template>
    <div class="chapter-tree-wrapper">

        <div v-if="getChapterTree" class="chapter-tree--chapter-list">

            <div v-for="(chapter, i) in getChapterTree.chapters"
                 :key="chapter.code"
                 class="chapter-item"
                 :class="{
                     'chapter-item--open': isChapterOpen(chapter.code),
                     'chapter-item--hidden': (crtOpenChapterCode !== null && !isChapterOpen(chapter.code)),
                     'chapter-item--is-subchapter-open': (crtOpenSubchapterCode !== null),
                 }">

                <div class="chapter-list-row"
                     @click="toggleChapter(chapter.code)"
                     :id="'CHAPTER_' + chapter.code"
                >
                    <div class="chapter-list-row--chapter-icon">
                        <chapter-icon :image="chapter.imagePath" color="primary"></chapter-icon>
                    </div>
                    <div class="chapter-list-row--name">
                        {{chapter.name}}
                    </div>

                    <v-icon class="chapter-list-row--icon--close"><!-- @TODO Must be replaced with <img> tag that loads the SVG file. -->
                        clear
                    </v-icon>

                    <span class="clearfix"></span>
                </div>

                <div class="chapter-item--children-container">

                    <!-- WITH SUBCHAPTERS -->

                    <div v-if="getChapterTree.hasSubChapters"
                         class="chapter-tree--subchapter-list">

                        <div v-for="(subChapter, index) in chapter.subChapters"
                             :key="subChapter.code"
                             class="subchapter-item"
                             :class="{
                                 'subchapter-item--open': isSubchapterOpen(subChapter.code),
                                 'subchapter-item--hidden': (crtOpenSubchapterCode !== null && !isSubchapterOpen(subChapter.code))
                             }">

                            <div class="subchapter-list-row"
                                 @click="toggleSubchapter(subChapter.code)"
                                 :id="'SUBCHAPTER_' + subChapter.code"
                            >
                                <div class="subchapter-list-row--name">
                                    {{subChapter.name}}
                                </div>

                                <v-icon class="subchapter-list-row--icon--close"><!-- @TODO Must be replaced with <img> tag that loads the SVG file. -->
                                    clear
                                </v-icon>
                            </div>

                            <div class="subchapter-item--children-container">
                                <main-symptom-list
                                    v-if="isSubchapterOpen(subChapter.code)"
                                    :symptoms="subChapter.symptoms"
                                    :selectedMainSymptomCode="crtSelectedMainSymptomCode"
                                    symptomListSourceType="CHAPTER_TREE"
                                    @onMainSymptomSelected="handleMainSymptomSelected"
                                ></main-symptom-list>
                            </div>

                        </div>
                    </div>

                    <!-- WITHOUT SUBCHAPTERS -->
                    <main-symptom-list v-else
                                       :symptoms="chapter.symptoms"
                                       :selectedMainSymptomCode="crtSelectedMainSymptomCode"
                                       symptomListSourceType="CHAPTER_TREE"
                                       @onMainSymptomSelected="handleMainSymptomSelected"
                    ></main-symptom-list>
                </div>

            </div>

        </div>


        <div class="chapter-tree--confirm-btn-container confirm-selected-main-symptom">
            <btn-confirm-main-symptom v-if="mustShowConfirmBtn"
                                      :isVisible="mustShowConfirmBtn"
                                      :crtSelectedMainSymptom="crtSelectedMainSymptom"
                                      symptomSourceType="CHAPTER_TREE"
                                      @onMainSymptomConfirmed="handleMainSymptomConfirmed"></btn-confirm-main-symptom>
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>

    import {mapGetters} from 'vuex';
    import ChapterIcon from "../../ChapterIcon";
    import MainSymptomList from "./MainSymptomList";
    import BtnConfirmMainSymptom from "./BtnConfirmMainSymptom";


    export default {
        name: 'ChapterTree',
        components: {
            MainSymptomList,
            ChapterIcon,
            BtnConfirmMainSymptom
        },
        data() {
            return {
                crtOpenChapterCode: null,
                crtOpenSubchapterCode: null,
                crtSelectedMainSymptom: null,
                // crtSelectedMainSymptomCode: ''
            }
        },

        computed: {
            ...mapGetters({
                getChapterTree: 'ChatBotStore/getChapterTree',
                getConfirmedMainSymptom: 'ChatBotStore/getConfirmedMainSymptom',
            }),

            crtSelectedMainSymptomCode() {
                if (this.crtSelectedMainSymptom !== null && typeof this.crtSelectedMainSymptom !== 'undefined') {
                    return this.crtSelectedMainSymptom.code;
                }
                else {
                    return "";
                }
            },

            mustShowConfirmBtn() {

                let mustShowConfirmBtn = false;

                if ((this.getChapterTree.hasSubChapters === true && this.crtOpenSubchapterCode !== null)
                        || (this.getChapterTree.hasSubChapters !== true && this.crtOpenChapterCode !== null)) {
                    mustShowConfirmBtn = true;
                }

                return mustShowConfirmBtn;
            }
        },

        mounted() {
            if (this.getConfirmedMainSymptom !== null) {
                this.crtSelectedMainSymptom = this.getConfirmedMainSymptom;
                this.crtOpenChapterCode = ((typeof this.getConfirmedMainSymptom.chapterCode !== "undefined") ? this.getConfirmedMainSymptom.chapterCode : null);
                this.crtOpenSubchapterCode = ((typeof this.getConfirmedMainSymptom.subchapterCode !== "undefined") ? this.getConfirmedMainSymptom.subchapterCode : null);
            }

            this.$nextTick(() => {
                this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
            });

        },

        beforeDestroy() {
            this.crtOpenChapterCode = null;
            this.crtOpenSubchapterCode = null;
        },


        methods: {

            isChapterOpen(chapterCode) {
                return (chapterCode === this.crtOpenChapterCode) ? true : false;
            },

            scrollToBottom() {

                let scrollHeight = Math.max(
                    document.body.scrollHeight,
                    document.body.offsetHeight,
                    document.documentElement.clientHeight,
                    document.documentElement.scrollHeight,
                    document.documentElement.offsetHeight
                );
                let maxScrollTop = scrollHeight - window.innerHeight;

                this.UtilitiesPlugin.smoothScrollTo(maxScrollTop);
            },

            toggleChapter(chapterCode) {
                if (chapterCode === this.crtOpenChapterCode) {
                    this.crtOpenChapterCode = null; // Close chapter.
                }
                else {
                    this.crtOpenChapterCode = chapterCode; // Open chapter.
                }

                this.$nextTick(() => {
                    this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
                });
            },

            isSubchapterOpen(subchapterCode) {
                return (subchapterCode === this.crtOpenSubchapterCode) ? true : false;
            },

            toggleSubchapter(subchapterCode) {
                if (subchapterCode === this.crtOpenSubchapterCode) {
                    this.crtOpenSubchapterCode = null; // Close subchapter.
                }
                else {
                    this.crtOpenSubchapterCode = subchapterCode; // Open subchapter.
                }

                this.$nextTick(() => {
                    this.PfChatbotChooseMainSymptomPlugin.setScrollableContentHeight();
                });
            },


            handleMainSymptomSelected(selectedSymptom) {
                this.crtSelectedMainSymptom = selectedSymptom;
            },

            handleMainSymptomConfirmed() {
                let rootElement = document.getElementsByClassName('root-pf-chatbot')[0];
                rootElement.classList.remove('hide-scroll');

                // Close "Choose Main Symptom" popup.
                this.$store.commit("ChatBotStore/setMustShowChooseMainSymptomPopup", false);

                this.PfChatbotPlugin.handleAnswerClick();
            },

        }
    }

</script>

<!-- ################################################################## -->

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/main-symptom-popup/ChapterTree.vue